var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoticias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#831131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.9,60V32.6H143V20.3H20.5v152.8H22l135.4,0c0,0,0,0,0,0s0,0,0,0h1.4v-0.1c8.9-0.7,16-8.2,16-17.4V60H158.9z    M23.5,170.2V23.3H140v9.2H140v123.2c0,6,3,11.3,7.7,14.4L23.5,170.2z M171.8,155.7c0,8-6.5,14.4-14.4,14.4   c-8,0-14.4-6.5-14.4-14.4V35.6h12.9v25.9V63v87.6h3V63h12.9V155.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.2,
    y: 61,
    width: 28.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.2,
    y: 78.2,
    width: 28.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.2,
    y: 95.4,
    width: 28.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.2,
    y: 112.6,
    width: 28.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.1,
    y: 132.3,
    width: 88.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.1,
    y: 147.6,
    width: 88.8,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3,60.3H34.8v56.8h52.4V60.3z M84.3,114.1H37.8V63.3h46.4V114.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticias);
export default __webpack_public_path__ + "static/media/noticias.10b0d99ce10cb7e6823d34bdc83ecf52.svg";
export { ForwardRef as ReactComponent };